import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { Alert, Popconfirm } from "antd"
import moment from "moment"

import { Link } from "react-router-dom"

import { discardRun, selectOpenRuns, selectRun } from "../clientBatchingSlice"

// A run created by a sweep holds its clients until it is discarded or finalized, but the sweep
// result itself only lives in redux -- so after a page reload the hold was invisible and there was
// no way to release it. This surfaces any open run of the current user's on page load, using the
// open_runs the picker endpoint already returns.
export default function OpenRunBanner() {
    const dispatch = useDispatch()
    const openRuns = useSelector(selectOpenRuns)
    const justSwept = useSelector(selectRun)

    const myRuns = (openRuns || []).filter((run) => run.held_by_current_user)

    // Nothing to say, or the sweep result below is already showing this run with its own Discard.
    if (myRuns.length === 0) return null
    if (justSwept && myRuns.length === 1 && myRuns[0].id === justSwept.id) return null

    return (
        <>
            {myRuns.map((run) => (
                <Alert
                    key={run.id}
                    type="info"
                    showIcon
                    style={{ marginBottom: "16px" }}
                    message={`You have an open client batching run from ${moment(run.created_at).format("h:mm A")}`}
                    description={
                        <span>
                            Run #{run.id} holds{" "}
                            {run.client_names && run.client_names.length > 0
                                ? run.client_names.join(", ")
                                : `${run.client_ids.length} client(s)`}
                            {typeof run.bill_count === "number" ? ` · ${run.bill_count} bill(s) swept` : ""}
                            {run.flagged_count > 0 ? `, ${run.flagged_count} red-flagged` : ""}. Those
                            clients cannot be swept again until this run is discarded or finalized.
                        </span>
                    }
                    action={
                        <>
                            <Link to={`/client_batching/runs/${run.id}`} style={{ marginRight: "12px" }}>
                                Resume
                            </Link>
                            <Popconfirm
                            title="Discard this run? The clients it holds are released and no bill is changed."
                            okText="Discard"
                            cancelText="Keep"
                            onConfirm={() => dispatch(discardRun(run.id))}
                        >
                                <a href="javascript:;">Discard</a>
                            </Popconfirm>
                        </>
                    }
                />
            ))}
        </>
    )
}
